module.exports = __webpack_public_path__ + "static/media/group-running-with-coach.3affd7e9.jpg";